import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'
import { urlService } from './urlService'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(urlService)
}

export const editor = site
